import {
    Icon,
    IconButton
} from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';
import { useEffect, useMemo, useState } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { CommonTable } from '../../_components/table/common.table';
import { PaperTableHeader } from '../../_components/table/header.table';
import { TABLE_FILTER } from '../../_const/tableFilter.const';
import { handleErrorResponse } from '../../_helpers/handleResponse.helper';
import { SearchTableHeader } from '../../_components/table/search.table';
import { TicketActionListManageDrawer } from './ticketActionList-manage';
import { ticketActionListService } from '../../_services/ticketActionList.service';

export function TicketActionListIndex() {
    const [data, setData] = useState<any>({ items: [], count: 10 });
    const [filter, setFilter] = useState({ ...TABLE_FILTER });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const fetchData = async () => {
        setIsLoading(true);
        return await ticketActionListService.getAll(filter)
            .then(
                json => {
                    setData(json);
                }, handleErrorResponse)
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        fetchData();
    }, [filter]);

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                id: 'actions',
                header: 'Actions',
                size: 80,
                enableSorting: false,
                enableColumnFilter: false,
                Cell: ({ row }) => (
                    <IconButton
                        color="primary"
                        onClick={() => { navigate("Manage/" + row.original.id) }}>
                        <Icon>edit</Icon>
                    </IconButton>
                ),
            },
            {
                accessorKey: 'id',
                header: 'ID',
            },
            {
                accessorKey: 'name',
                header: 'Name',
            },
            {
                accessorKey: 'ticketType',
                header: 'Ticket Type',
            },
            {
                accessorKey: 'status',
                header: 'Status',
            },
        ],
        []
    );

    return (
        <>
            <PaperTableHeader title="Ticket Actions List" buttons={[
                { icon: "add", label: "Create", onClick: () => { navigate("Create") } }
            ]} />

            <SearchTableHeader inputs={[
                { label: "Name", name: "name", onChange: setFilter, value: filter.name },
                { label: "Ticket Type", name: "ticketType", onChange: setFilter, value: filter.ticketType },
            ]} />

            <CommonTable
                columns={columns}
                data={data}
                filter={filter}
                setFilter={setFilter}
                loading={isLoading}
            />

            <Routes>
                <Route path="Create" element={<TicketActionListManageDrawer onSave={() => { navigate(""); fetchData(); }} onClose={() => { navigate("") }} />} />
                <Route path="Manage/:id" element={<TicketActionListManageDrawer onSave={() => { navigate(""); fetchData(); }} onClose={() => { navigate("") }} />} />
            </Routes>

        </>
    );
}
